@if (!this.loading && !alarma) {
  <app-breadcrumb
    listado="/main/alarmas/alarmasDomiciliarias"
    etiquetaListado="Alarmas domiciliarias"
    [titulo]="encabezado?.nombre"
  ></app-breadcrumb>
  <app-empty-state
    icon="notifications_off"
    message="No se encontró la alarma"
  ></app-empty-state>
} @else if (!this.loading) {
  <app-breadcrumb
    listado="/main/alarmas/alarmasDomiciliarias"
    etiquetaListado="Alarmas domiciliarias"
    [titulo]="encabezado?.nombre"
  ></app-breadcrumb>

  <!-- Encabezado con la misma estética que las tarjetas de la pestaña Info -->
  <header class="encabezado">
    <div class="encabezado-avatar"><mat-icon>doorbell</mat-icon></div>
    <div class="encabezado-texto">
      <h1>{{ encabezado?.nombre }}</h1>
      @if (direccion) {
        <span class="encabezado-nombre">{{ direccion }}</span>
      }
      <div class="encabezado-chips">
        @for (chip of chips; track chip.label) {
          <span class="chip" [class.estado-alerta]="chip.estado === 'alerta'">
            @if (chip.icon) {
              <mat-icon>{{ chip.icon }}</mat-icon>
            }
            {{ chip.label }}
          </span>
        }
        @if (alarma.idServiciosContratados?.length) {
          <app-mostrar-servicios
            [linea]="true"
            [idsServicios]="alarma.idServiciosContratados"
            [size]="25"
            [rounded]="true"
          ></app-mostrar-servicios>
        }
      </div>
    </div>
    <!-- Mismo permiso que pide el listado para editar -->
    @if (puedeEditar) {
      <button
        irxBotonIcono
        class="encabezado-editar"
        (click)="editar()"
        tooltip="Editar alarma"
      >
        <mat-icon>edit</mat-icon>
      </button>
    }
  </header>

  <mat-tab-group
    [(selectedIndex)]="selectedTab"
    (selectedTabChange)="tabChanged($event)"
    class="tabs-detalle"
  >
    <!-- Info -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">info</mat-icon>
        <span>Info</span>
      </ng-template>
      <ng-template matTabContent>
        <app-detalles-alarma-info></app-detalles-alarma-info>
      </ng-template>
    </mat-tab>

    <!-- Historial Eventos -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">report</mat-icon>
        <span>Historial Eventos</span>
      </ng-template>
      <ng-template matTabContent>
        <app-eventos-genericos-historico
          [id]="alarma?._id"
          tipoEventoFijo="Evento Alarma"
        ></app-eventos-genericos-historico>
      </ng-template>
    </mat-tab>

    <!-- Cámaras: sin el módulo no se muestra (/camaras responde 403); sin
         cámaras asociadas queda deshabilitada. -->
    @if (permisosEntidades.verModuloCamaras()) {
      <mat-tab [disabled]="!alarma?.idsCamaras?.length">
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">videocam</mat-icon>
          <span>Cámaras</span>
        </ng-template>
        <ng-template matTabContent>
          <!-- Sin alto impuesto: el host de camaras-multiple tiene overflow
               hidden y cualquier altura recorta el mosaico y los controles de
               paginación. Si no entra, scrollea la pestaña. -->
          <app-camaras-multiple
            style="display: block; width: 100%"
            [data]="alarma.idsCamaras"
          ></app-camaras-multiple>
        </ng-template>
      </mat-tab>
    }

    <!-- Eventos Personalizados -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">rule</mat-icon>
        <span>Eventos Personalizados</span>
      </ng-template>
      <ng-template matTabContent>
        <app-listado-configs-eventos
          [dispositivo]="alarma"
          tipo="Alarma"
        ></app-listado-configs-eventos>
      </ng-template>
    </mat-tab>

    @if (helper.tienePermiso('Logs - Ver logs crudos alarmas')) {
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">terminal</mat-icon>
          <span>Logs Crudos</span>
        </ng-template>
        <ng-template matTabContent>
          <app-listado-logs-crudos
            [idEntidad]="alarma?._id"
            tipoEntidad="Alarma"
          ></app-listado-logs-crudos>
        </ng-template>
      </mat-tab>
    }

    <!-- Control Horario -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">schedule</mat-icon>
        <span>Control Horario</span>
      </ng-template>
      <ng-template matTabContent>
        <app-visualizador-horario-tab
          [alarma]="alarma"
        ></app-visualizador-horario-tab>
      </ng-template>
    </mat-tab>

    <!-- Notas -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">note</mat-icon>
        <span>Notas</span>
      </ng-template>
      <ng-template matTabContent>
        <app-listado-notas
          [idAsignado]="alarma?._id"
          [idCliente]="alarma?.idCliente"
          tipo="Nota"
          tipoDispositivo="Alarma"
        ></app-listado-notas>
      </ng-template>
    </mat-tab>

    <!-- Contacto -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">contacts</mat-icon>
        <span>Contactos</span>
      </ng-template>
      <ng-template matTabContent>
        <app-listado-notas
          [idAsignado]="alarma?._id"
          [idCliente]="alarma?.idCliente"
          tipo="Contacto"
          tipoDispositivo="Alarma"
        ></app-listado-notas>
      </ng-template>
    </mat-tab>

    <!-- Servicio Técnico -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">build</mat-icon>
        <span>Servicio Técnico</span>
      </ng-template>
      <ng-template matTabContent>
        <app-eventos-tecnicos-genericos
          [id]="alarma._id"
        ></app-eventos-tecnicos-genericos>
      </ng-template>
    </mat-tab>

    <!-- Asignaciones -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">assignment</mat-icon>
        <span>Asignaciones</span>
      </ng-template>
      <ng-template matTabContent>
        <app-listado-asignacions
          [idEntidad]="alarma?._id"
          [tipoEntidad]="'modificada'"
        ></app-listado-asignacions>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
} @else {
  <app-detalle-esqueleto
    icono="doorbell"
    listado="/main/alarmas/alarmasDomiciliarias"
    etiquetaListado="Alarmas domiciliarias"
    [pestanas]="10"
  ></app-detalle-esqueleto>
}
